import React from 'react';
import './Logo.css';

interface LogoProps {
	size?: 'small' | 'large';
	className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 'small', className = '' }) => {
	const sizeClass = size === 'large' ? 'welcome-logo' : '';

	return (
		<div className={`${sizeClass} ${className}`}>
			<img src={require('../assets/images/logo.png')} alt='Centar za zaštitu žrtava trgovine ljudima' className='logo-image' />
		</div>
	);
};
